import React from 'react'
import { Argument as ClassName } from 'classnames'

import useText from '../common/hooks/useText'
import { SelectButton } from '../common/uikit/SelectButton'

export const SCHUKO_FUNCTION_TYPE = 'Schuko'
export const SOCKET_FUNCTION_TYPE = 'Socket'

export default function ConnectorSelect({ connectors, value, onChange }: Props): React.ReactElement {
    const text = useText()

    const getConnectorName = (
        connectorId?: IConnectorId,
        connectors?: Array<{ connectorId: IConnectorId; connectorFunctionType: string }>
    ): string => {
        const connector = connectors?.find((connector) => connector.connectorId === connectorId)
        if (!connector || !connectors?.length) return 'Connector'

        const hasSchuko = connectors.some((connector) => connector.connectorFunctionType === SCHUKO_FUNCTION_TYPE)
        if (hasSchuko) {
            if (connector.connectorFunctionType === SCHUKO_FUNCTION_TYPE) {
                if (connectors.length > 1) return text('lblSocketOnly')
                return text('lblSocket')
            }
            if (connectors.length > 1) return text('lblChargerOnly')
            return text('lblCharger')
        }

        if (connectors.length > 1) {
            if (connectorId === 1) return text('lblLeftSocket')
            return text('lblRightSocket')
        }

        return text('lblSocketWithId', {
            connectorId,
        })
    }

    const options = connectors.map((connector) => ({
        label: getConnectorName(connector.connectorId, connectors),
        value: connector.connectorId,
    }))

    return (
        <div className="sm:w-12 md:w-6 lg:w-4">
            <SelectButton<IConnectorId>
                id="connector-select"
                ariaLabel={text('lblConnectorSettings')}
                value={value}
                options={options}
                onChange={onChange}
                fullWidth
            />
        </div>
    )
}

export enum ConnectorType {
    CHARGER = 1,
    SOCKET = 2,
}

export type IConnectorId = ConnectorType.CHARGER | ConnectorType.SOCKET

export type Props = {
    className?: ClassName
    connectors: Array<{ connectorId: IConnectorId; connectorFunctionType: string }>
    onChange: (connectorId: IConnectorId) => void
    value?: IConnectorId
    defaultValue?: IConnectorId
}
